import { GestorDashboardBreakdownList, GestorDashboardMonthlyBars } from '@/components/Gestores/GestorDashboardWidgets'
import { GestorDashboardOverviewKpis } from '@/components/Gestores/GestorDashboardOverviewKpis'
import type { GestorDashboardOverview, GestorDashboardSummary } from '@/components/Gestores/gestorDashboardTypes'

type Props = {
  overview: GestorDashboardOverview
  summary: GestorDashboardSummary
}

export function GestorDashboardOverviewView({ overview, summary }: Props) {
  return (
    <div className='space-y-6'>
      <GestorDashboardOverviewKpis overview={overview} summary={summary} />

      <section className='space-y-3'>
        <div>
          <h3 className='text-sm font-semibold text-text-primary'>Distribuição de esforço</h3>
          <p className='mt-0.5 text-xs text-text-muted'>Ranking por executor e cliente no período.</p>
        </div>
        <div className='grid gap-4 xl:grid-cols-2'>
          <GestorDashboardBreakdownList title='Esforço por executor' rows={summary.byExecutor} />
          <GestorDashboardBreakdownList title='Esforço por cliente' rows={summary.byWorkspace} />
        </div>
      </section>

      <section className='space-y-3'>
        <div>
          <h3 className='text-sm font-semibold text-text-primary'>Tendência mensal</h3>
          <p className='mt-0.5 text-xs text-text-muted'>Volume de demandas ao longo dos meses.</p>
        </div>
        <GestorDashboardMonthlyBars title='Volume de demandas mensais' rows={overview.monthlyVolume} valueKey='count' />
      </section>
    </div>
  )
}
